import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const ACCOUNT_MENU: PermissionTableRowType = {
  name: '계정',
  key: 'ACCOUNT_MANAGE',
  subRows: [
    {
      name: '판매자 관리',
      key: PERMISSION_SUBJECTS.SELLER,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.SELLER,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '판매자 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.SELLER,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
    {
      name: '유저 관리',
      key: PERMISSION_SUBJECTS.USER,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.USER,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '유저 상세조회',
          key: PERMISSION_SUBJECTS.USER,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '유저 편집',
          key: PERMISSION_SUBJECTS.USER,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '유저 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.USER,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
    {
      name: '유저 랭킹',
      key: PERMISSION_SUBJECTS.USER_RANK,
      permissions: [PERMISSION_ACTIONS.READLIST],
    },
  ],
};
